// Vendor Libs
import React from 'react';

// Components
import UserForm from './user-form';

// Containers
import FormData from '../../containers/form-data';

const formName = 'createUser';

const CreateUser = () => (
    <FormData formName={formName}>
        {({resetForm}) => <UserForm className="create-user" formName={formName} onReset={resetForm} />}
    </FormData>
);

export default CreateUser;
